import './UserDetailsAccount.scss';
import { ReactElement } from 'react';
import { DashboardContainer } from '../../../../modules/common/dashboard/DashboardContainer';
import { SpaceBetweenLayout } from '../../../../modules/common/layouts/spaceBetweenLayout/SpaceBetweenLayout';
import { UserDetailsHeader } from '../../../modules/user/components/UserDetailsHeader';
import { PersonalInformationWidgetContainer } from '../../../modules/user/containers/personalInformations/PersonalInformationWidget.container';
import { UserPlanWidgetContainer } from '../../../modules/user/containers/UserPlanWidget.container';

export const UserDetailsAccountView = (): ReactElement => (
  <DashboardContainer>
    <UserDetailsHeader />
    <div className='user-details-account'>
      <SpaceBetweenLayout>
        <PersonalInformationWidgetContainer />
        <UserPlanWidgetContainer />
      </SpaceBetweenLayout>
    </div>
  </DashboardContainer>
);
